import * as actionType from './QuotationActions';
import { ApiGateWay } from '../../../ApiGateWay/ApiGateWay';
import { Config } from '../../../config/config';
import Cookie from 'js-cookie';
import LZString from 'lz-string';
const config = JSON.parse(Config);
const apiInterface = config['api1'];

const initialState = {
    message: '',
    modalOpen: false,
    loading: false,
    apiStatus:false,
}
export const GetAllQuotations = (data) => ({
    type: actionType.Get_ALL_QUOTATIONS,
    payload: data,
})
export const ClearMessage = () => ({
    type: actionType.CLEAR_MESSAGESS,
})
export const apiStatus = (data) => ({
    type: actionType.API_CALL_STATUS,
    payload: data,
})
export const quatationList = (data)=>({
    type:actionType.IS_QUATATION_LIST,
    payload:data
})
export const QuotationDetailsData = (data)=>({
    type:actionType.QUOTATION_ITEM_DETAILS,
    payload:data
})
export const getLoadallQuotations= () => async (dispatch) => {
    const jsonData = Cookie.get('currentUser');
    let decompressedData = LZString.decompressFromBase64(jsonData);
    decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
    const user = JSON.parse(decompressedData);
        const data = {
        'fedid': user['userId'],
    }
    initialState.loading = true;
    dispatch(apiStatus(initialState))
    ApiGateWay.SaveData(
        apiInterface +
        '/PMPInfo/loadallQuotationRequestInfo',data)
        .then((response) => {
            console.log(response,'dataresponse')
            initialState.loading = false;
            if (response[0]?.Table1[0]?.status_code == '000') {
                const StoreDetails = response[3].Table4;
                const QuotationDetails = response[6].Table7;
                const QuotationData = response[7].Table8;
                const QuatationInfo = {QuotationDetails, QuotationData, StoreDetails}
                initialState.message = response[0]?.Table1[0]?.status_msg
                initialState.modalOpen = false
                dispatch(apiStatus(initialState))
                dispatch(GetAllQuotations(QuatationInfo))
            } else {
                initialState.apiStatus=false
                initialState.loading = false;
                initialState.modalOpen = true;
                initialState.message = response[1]?.Table1[2]?.status_msg;
                dispatch(apiStatus(initialState))
            }
        })
        .catch((e) => {
            initialState.apiStatus=false
            initialState.loading = false;
            initialState.modalOpen = true;
            initialState.message = 'Something went wrong please try again after sometime'
            dispatch(apiStatus(initialState))
            
        })
}

export const UpdateQuotation = (data) => async (dispatch) => {
    initialState.loading = true;
    dispatch(apiStatus(initialState))
    ApiGateWay.SaveData(apiInterface + "/PMPInfo/UpdateQuotation", data)
        .then((result) => {console.log(result,'UpdateQuotationResult')
            initialState.loading = false;
            if (result[0].Table1[0].status_code === '000') {
                initialState.message = result[1].Table2[0].status_msg
                initialState.apiStatus=true;
                initialState.modalOpen = true;
                dispatch(apiStatus(initialState))
            }else{
                initialState.modalOpen = true;
                initialState.apiStatus=false;
                initialState.apiStatus = false;
                initialState.message = result[0]?.Table1[0]?.status_msg
                // dispatch(APIStart(initialState))
                dispatch(apiStatus(initialState))
            }
        })
        .catch(() => {
            initialState.loading = false;
            initialState.apiStatus=false
            initialState.modalOpen = true;
            initialState.message = 'Something went wrong please try again after sometime'
            // dispatch(APIStart(initialState))
            dispatch(apiStatus(initialState))
        })
}

export const CreateQuotation = (data) => async (dispatch) => {
    initialState.loading = true;
    dispatch(apiStatus(initialState))
    ApiGateWay.SaveData(apiInterface + "/PMPInfo/CreateQuotation", data)
        .then((result) => {console.log(result,'result for createQuatation')
            initialState.loading = false;
            if (result[0].Table1[0].status_code === '000') {
                initialState.message = result[1].Table2[0].status_msg
                initialState.apiStatus=true;
                initialState.modalOpen = true;
                dispatch(apiStatus(initialState))
            }else{
                initialState.modalOpen = true;
                initialState.apiStatus=false;
                initialState.loading = false;
                initialState.message = result[0]?.Table1[0]?.status_msg
                // dispatch(APIStart(initialState))
                dispatch(apiStatus(initialState))
            }
        })
        .catch(() => {
            initialState.loading = false;
            initialState.apiStatus=false
            initialState.modalOpen = true;
            initialState.message = 'Something went wrong please try again after sometime'
            // dispatch(APIStart(initialState))
            dispatch(apiStatus(initialState))
        })
}
export const QuotationItemDetails= (value) => async (dispatch) => {
    const jsonData = Cookie.get('currentUser');
          let decompressedData = LZString.decompressFromBase64(jsonData);
          decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
          const user = JSON.parse(decompressedData);
       const data = {
        'fedid': user['userId'],
        'work_request_id':value,
    }
    initialState.loading = true;
    ApiGateWay.SaveData(
        apiInterface +
        '/PMPInfo/QuotationItemDetails',data)
        .then((response) => {
            console.log(response,'QuotationItemDetails')
            initialState.loading = false;
            if (response[0]?.Table1[0]?.status_code == '000') {
                const QuotationDetails = response[1].Table2;
                const QuotationHistory = response[3].Table4;
                const vendorCommentsTable = response[4].Table5;
                initialState.message = response[0]?.Table1[0]?.status_msg
                initialState.modalOpen = false
                let data = {QuotationDetails, QuotationHistory, vendorCommentsTable}
                dispatch(QuotationDetailsData(data))
                // dispatch(apiStatus(initialState))
                // dispatch(GetAllQuotations(QuatationInfo))
            } else {
                initialState.apiStatus=false
                initialState.loading = false;
                initialState.modalOpen = true;
                initialState.message = response[1]?.Table1[2]?.status_msg;
            }
        })
        .catch((e) => {
            initialState.apiStatus=false
            initialState.loading = false;
            initialState.modalOpen = true;
            initialState.message = 'Something went wrong please try again after sometime'
            
        })
}
export const GetQuotationRemarks = (data) => ({
    
    type: actionType.QUOTATION_REMARKS,
    payload: data,
})
export const QuotationRemarks= (workrequestid) => async (dispatch) => {
    const jsonData = Cookie.get('currentUser');
          let decompressedData = LZString.decompressFromBase64(jsonData);
          decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
          const user = JSON.parse(decompressedData);
        const data = {
        'fedid': user['userId'],
        'work_request_id':workrequestid,
    }
    initialState.loading = true;
    ApiGateWay.SaveData(
        apiInterface +
        '/PMPInfo/QuotationItemDetails',data)
        .then((response) => {
            initialState.loading = false;
            console.log(response,'response form QuotationItemDetails')
            if (response[0]?.Table1[0]?.status_code == '000') {
                const quotationItemDetails = response[2]?.Table3;
                initialState.message = response[0]?.Table1[0]?.status_msg
                initialState.modalOpen = false
                dispatch(GetQuotationRemarks(quotationItemDetails))
            } else {
                initialState.apiStatus=false
                initialState.loading = false;
                initialState.modalOpen = true;
                initialState.message = response[1]?.Table1[2]?.status_msg;
            }
        })
        .catch((e) => {
            initialState.apiStatus=false
            initialState.loading = false;
            initialState.modalOpen = true;
            initialState.message = 'Something went wrong please try again after sometime'
            
        })
}